// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --upcare-value-bienveillance: #fed14c;
  --upcare-value-bienveillance-soft: #fff4c7;
  --upcare-value-engagement: #2894d2;
  --upcare-value-engagement-soft: #dff2fc;
  --upcare-value-faire-equipe: #e71873;
  --upcare-value-faire-equipe-soft: #fde2ee;
  --upcare-value-respect: #2fac68;
  --upcare-value-respect-soft: #def5e8;

  --upcare-value-track: #e8eaec;
  --upcare-value-text: #263746;
}

[aria-label="Données des services du pôle"] button > span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  margin-left: 6px;
  padding: 0 5px;
  border-radius: 999px;
  background: var(--upcare-value-faire-equipe);
  color: #fff;
  font-size: 0.7rem;
  font-weight: 700;
  line-height: 1;
}
`, "",{"version":3,"sources":["webpack://./src/styles/values-theme.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,kCAAkC;EAClC,uCAAuC;EACvC,oCAAoC;EACpC,yCAAyC;EACzC,+BAA+B;EAC/B,oCAAoC;;EAEpC,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,4CAA4C;EAC5C,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":[":root {\n  --upcare-value-bienveillance: #fed14c;\n  --upcare-value-bienveillance-soft: #fff4c7;\n  --upcare-value-engagement: #2894d2;\n  --upcare-value-engagement-soft: #dff2fc;\n  --upcare-value-faire-equipe: #e71873;\n  --upcare-value-faire-equipe-soft: #fde2ee;\n  --upcare-value-respect: #2fac68;\n  --upcare-value-respect-soft: #def5e8;\n\n  --upcare-value-track: #e8eaec;\n  --upcare-value-text: #263746;\n}\n\n[aria-label=\"Données des services du pôle\"] button > span {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 18px;\n  height: 18px;\n  margin-left: 6px;\n  padding: 0 5px;\n  border-radius: 999px;\n  background: var(--upcare-value-faire-equipe);\n  color: #fff;\n  font-size: 0.7rem;\n  font-weight: 700;\n  line-height: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
